module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Video Pembelajaran'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Daftar Video")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Daftar Video\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text mr-2",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createVideo()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                Video\n            ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text mr-2",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.reportVideo()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chart-bell-curve")]), _vm._v("\n                Lihat Laporan\n            ")], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0 py-3 border-top-1"
  }, [_c('div', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    staticClass: "d-flex align-center flex-wrap justify-center no-gutters gap-10"
  }, [_c('v-col', [_c('v-autocomplete', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Kelas",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "items": _vm.gradeList
    },
    on: {
      "change": function($event) {
        return _vm.fetchData()
      }
    },
    model: {
      value: (_vm.grade),
      callback: function($$v) {
        _vm.grade = $$v
      },
      expression: "grade"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-autocomplete', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Kurikulum",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "items": [{
          text: 'KM',
          value: 'KM'
        },
        {
          text: 'K13',
          value: 'K13'
        },
        {
          text: 'K13 IPA',
          value: 'SAINTEK'
        },
        {
          text: 'K13 IPS',
          value: 'SOSHUM'
        },
        {
          text: 'TKA',
          value: 'TKA'
        } ],
      "item-text": "text",
      "item-value": "value"
    },
    on: {
      "change": function($event) {
        return _vm.fetchData()
      }
    },
    model: {
      value: (_vm.kurikulum),
      callback: function($$v) {
        _vm.kurikulum = $$v
      },
      expression: "kurikulum"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-autocomplete', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Mata Pelajaran",
      "clearable": "",
      "dense": "",
      "outlined": "",
      "items": _vm.mapelList,
      "item-text": "nama",
      "item-value": "nama"
    },
    on: {
      "change": function($event) {
        return _vm.getMapelByName()
      }
    },
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-select', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Bab",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "items": _vm.topics,
      "item-text": "nama",
      "item-value": "nama"
    },
    on: {
      "change": function($event) {
        return _vm.fetchData()
      }
    },
    model: {
      value: (_vm.bab),
      callback: function($$v) {
        _vm.bab = $$v
      },
      expression: "bab"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-select', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Status",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "items": [{
          text: 'Draft',
          value: 'DRAFT'
        },
        {
          text: 'Review',
          value: 'REVIEW'
        },
        {
          text: 'Publikasi',
          value: 'PUBLISHED'
        } ],
      "item-text": "text",
      "item-value": "value"
    },
    on: {
      "change": function($event) {
        return _vm.fetchData()
      }
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-card', {
    staticClass: "px-4 py-3 text-center",
    staticStyle: {
      "border": "2px solid #f0f3f9"
    },
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "grey--text font-weight-500"
  }, [_vm._v("\n                                Total Video\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-700 mt-1",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.total_count) + "\n                            ")])])], 1), _vm._v(" "), _c('v-col', [_c('v-card', {
    staticClass: "px-4 py-3 text-center",
    staticStyle: {
      "border": "2px solid #f0f3f9"
    },
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "grey--text font-weight-500"
  }, [_vm._v("\n                                Video Terpublikasi\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-700 mt-1",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.total_published) + "\n                                "), _c('span', {
    staticClass: "font-size-14"
  }, [_vm._v(" Video ")])])])], 1)], 1)], 1)]), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.videoList,
      "headers": _vm.headers,
      "has-action": true,
      "has-export": false,
      "hasMultiSearch": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "hasOpenNewTab": true,
      "custom-pagination-total-items": _vm.total_data,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.total_pages,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "doSearch": function($event) {
        _vm.search = $event;
        _vm.fetchData();
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editVideo()
      },
      "duplicateClicked": function($event) {
        return _vm.duplicateItem()
      },
      "deleted": function($event) {
        return _vm.confirmDelete($event)
      },
      "deleteOnFilter": function($event) {
        return _vm.delByOneFilter($event)
      },
      "openNewTab": function($event) {
        return _vm.openNewTab($event)
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('dialog-confirm', {
    attrs: {
      "title": _vm.dialogConfirm.title,
      "subtitle": _vm.dialogConfirm.subtitle
    },
    on: {
      "close": function($event) {
        _vm.dialogConfirm.open = false;
        _vm.dialogConfirm.title = null;
        _vm.dialogConfirm.function = null;
      },
      "confirm": function($event) {
        _vm.deleteVideo(_vm.dialogConfirm.function);
        _vm.dialogConfirm.open = false;
        _vm.dialogConfirm.title = null;
        _vm.dialogConfirm.function = null;
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogConfirm2.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm2, "open", $$v)
      },
      expression: "dialogConfirm2.open"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dialogConfirm2.title) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.dialogConfirm2.subtitle) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm2.open = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), (_vm.dialogConfirm2.function == 'onDuplicateConfirm') ? _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": _vm.onDuplicateConfirm
    }
  }, [_vm._v("\n                    OK\n                ")]) : _vm._e(), _vm._v(" "), (_vm.dialogConfirm2.function == 'onDuplicateCancel') ? _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": _vm.onDuplicateCancel
    }
  }, [_vm._v("\n                    OK\n                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "900px",
      "persistent": "",
      "height": "168px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.dialogConfirm2.title = 'Yakin ingin membatalkan duplikasi ?';
        _vm.dialogConfirm2.open = true;
        _vm.dialogConfirm2.function = 'onDuplicateCancel';
      }
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "width": "100%"
    }
  }, [_vm._v("\n                Detail Duplikat Video\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm2.title =
          'Yakin ingin membatalkan duplikasi ?';
        _vm.dialogConfirm2.open = true;
        _vm.dialogConfirm2.function = 'onDuplicateCancel';
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-4 px-6"
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            URL Video\n                        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Masukkan URL Video dan tekan enter",
      "outlined": ""
    },
    model: {
      value: (_vm.details.youtube_url),
      callback: function($$v) {
        _vm.$set(_vm.details, "youtube_url", $$v)
      },
      expression: "details.youtube_url"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50% !important",
      "padding": "0px 0px 20px 0px"
    }
  }, [_c('youtube', {
    ref: "youtube",
    attrs: {
      "video-id": _vm.$youtube.getIdFromUrl(
        _vm.details.youtube_url
      )
    },
    on: {
      "playing": _vm.playing
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pa-0"
  }, [_vm._v("\n                                Source\n                            ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.details.source),
      callback: function($$v) {
        _vm.$set(_vm.details, "source", $$v)
      },
      expression: "details.source"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Youtube",
      "value": "youtube",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Judul Video\n                            ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Judul Video",
      "outlined": ""
    },
    model: {
      value: (_vm.details.title),
      callback: function($$v) {
        _vm.$set(_vm.details, "title", $$v)
      },
      expression: "details.title"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Durasi\n                            ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "Durasi (dalam detik)",
      "outlined": ""
    },
    model: {
      value: (_vm.details.duration),
      callback: function($$v) {
        _vm.$set(_vm.details, "duration", $$v)
      },
      expression: "details.duration"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm2.title =
          'Yakin ingin membatalkan duplikasi ?';
        _vm.dialogConfirm2.open = true;
        _vm.dialogConfirm2.function = 'onDuplicateCancel';
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blew"
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm2.title =
          'Yakin ingin melakukan duplikasi pada Video ini ?';
        _vm.dialogConfirm2.open = true;
        _vm.dialogConfirm2.function = 'onDuplicateConfirm';
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-797c0a77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/vd_pembelajaran/components/VdPembelajaran.vue
// module id = 2159
// module chunks = 1